import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed, useSuccess } from "features/notification/hooks"
import { updateMeal } from "../mealSlice"
import { MealType } from "model/food/types"
import { IUpdateMealPayload } from "model/food/types/mealPayload.types"
import getMealPayloadFromMeal from "model/food/utils/getPayloads/getMealPayloadFromMeal"


export const useUpdateMeal = (callback?: () => void) => {
  const updateMealLoading = useAppSelector(
    (state) => state.meal.updateMealLoading,
  )
  const updateMealSuccess = useAppSelector(
    (state) => state.meal.updateMealSuccess,
  )
  const updateMealFailed = useAppSelector(
    (state) => state.meal.updateMealFailed,
  )

  const dispatch = useAppDispatch()

  const handleUpdateMeal = (meal: MealType) => {
    const mealPayload = getMealPayloadFromMeal(meal)
    mealPayload.isManualNutrition = meal.isManualNutrition ?? false
    
    const payload: IUpdateMealPayload = {
      id: meal.id,
      payload: mealPayload,
    }

    dispatch(updateMeal(payload))
  }

  useFailed(updateMealFailed)
  useSuccess(updateMealSuccess, { message: "" }, callback)

  return {
    updateMealLoading,
    handleUpdateMeal,
  }
}
